import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import './footer.scss'

class Footer extends React.Component {
render() {
  return (
    <Container className="footer__container">
        <Row className="footer__row">
            <Col xs="12" md={{ size: 7, offset: 1}}>
              <div>
                <span className="footer__widget--title">AMAZON ASSOCIATES PROGRAM</span>
                <br/>
                <p className="footer__widget-content">Amazon Associates Program Gardenlifepro.com is a participant in the Amazon Services LLC Associates Program, an affiliate advertising program designed to provide a means for sites to earn advertising fees by advertising and linking to Amazon.com. *Amazon and the Amazon logo are trademarks of Amazon.com, Inc., or its affiliates. Additionally, Gardenlifepro.com participates in various other affiliate programs, and we sometimes get a commission through purchases made through our links.</p>
              </div>
            </Col>
            <Col xs="12" md={{ size: 2, offset: 2}}>
              <div>
                <span className="footer__widget--title">PAGES</span>
                <br/><br/>
                <ul className="footer__ul">
                  <li><a href="/newsletter/" className="white--text">Newsletter</a></li>
                  <li><a href="/contact-us/" className="white--text">Contact Us</a></li>
                  <li><a href="/privacy-policy/" className="white--text">Privacy Policy</a></li>
                </ul>
              </div>
            </Col>
        </Row>
        <Row className="footer_row">
          <Col xs="12" md={{ size: 7, offset: 1}}>
            <div className="footer__copyright"></div>Copyright © 2022 Gardenlife Pro
          </Col>
          <Col xs="12" md={{ size: 2, offset: 2}}>
            <div><a href="//www.dmca.com/Protection/Status.aspx?ID=3e2f5ac5-d0ba-4bdd-adaa-88b0f9beba7a" title="DMCA.com Protection Status" className="dmca-badge"> <img src ="https://images.dmca.com/Badges/dmca_protected_sml_120m.png?ID=3e2f5ac5-d0ba-4bdd-adaa-88b0f9beba7a"  alt="DMCA.com Protection Status" /></a>  <script src="https://images.dmca.com/Badges/DMCABadgeHelper.min.js"> </script></div>
          </Col>
        </Row>
    </Container>
    )
  }
}

export default Footer
